export default "__VITE_ASSET__mMElCAhS__"